import React, { useState, useRef, useEffect } from "react";
import { Input, Button, Checkbox } from "antd";

import { useLocation, useNavigate } from "react-router-dom";
import StackChart from "../../StackChart";

import "./table.scss";
import { getFieldStyle } from "../../../themes";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";

export default function NuJobsTable({
    freeze = false,
    onClickCallBack = null,
    isClickable = false,
    titleList,
    data,
    isJDPage = false,
    isQsetJDPage = false,
    isEvalPage = false,
    columnWidth = [50, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
    resumePage = false,
}) {
  const [frozenColumns, setFrozenColumns] = useState(0);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];
  const [checkBoxData, setCheckBoxData] = useState(data);
  const {nuJobsUpdateResumeDetails,nujobsGetMyResumes} = useNuJobDetailsStore();

  useEffect(() => {
    let checkBoxArray = data
    if (resumePage) {
      checkBoxArray = data?.map((ele, rowIndex) => {
        return {
          selected: false,
          sn: ele.id,
          resumeName: ele.resumeName,
          skills: ele.skills,
          email: ele.email,
          contact: ele.contact,
          AddedOn: ele.AddedOn,
          Status: ele.Status,
          isDefault: ele.isDefault?"Yes":"No",
        };
      });
    }
    setCheckBoxData(checkBoxArray);
  }, [data]);

  if (!data) {
    return (
      <div style={{ textAlign: "center", margin: "30px", fontSize: "12px" }}>
        No Updates in the selected duration
      </div>
    );
  }
  const GetJobID = (title) => {
    const jd_array = title?.split("]");
    var jdID = jd_array[0]?.replace("[", "");
    return jdID;
  };

  const showPieChart = (tableInfo) => {
    if (tableInfo === "available_resumes") {
      return true;
    } else {
      return false;
    }
  };
  const getStickyStyle = (index, cellType) => {
    if (index >= frozenColumns) return {};

    // Calculate sum of widths of all previous columns to set the 'left' property
    const leftOffset = columnWidth
      .slice(0, index)
      .reduce((acc, curr) => acc + curr, 0);

    return {
      position: "sticky",
      left: `${leftOffset}px`,
      zIndex: 10,
      background: cellType === "title" ? "#99d2fd" : "#c0e4ff",
      boxShadow:
        index === frozenColumns - 1 ? "2px 0 5px -2px rgba(0,0,0,0.2)" : "none", // Adds a nice shadow line
    };
  };

  const handleCheckBoxChange = (rowIndex, isChecked) => {
    const updatedData = [...checkBoxData];
    updatedData[rowIndex].selected = isChecked;

    // Revert to original data if the checkbox is unchecked
    if (!isChecked && data && data[rowIndex]) {
      updatedData[rowIndex].resumeName = data[rowIndex].resumeName;
      updatedData[rowIndex].skills = data[rowIndex].skills;
    }

    setCheckBoxData(updatedData);
  };

  const resetCheckBox = () => {
    const resetData = checkBoxData.map((item, index) => ({
      ...item,
      selected: false,
    }));
    setCheckBoxData(resetData);
  };

  const handleUpdate = () => {
    var encodedJsonValues = {}
    encodedJsonValues.action = "UPDATE"
    encodedJsonValues.nujobsresumedata =[]
    var num =0
    for(let idx = 0; idx < checkBoxData.length; idx++){
        //console.log("checkBoxData", idx,checkBoxData[idx].selected)
        if (checkBoxData[idx].selected) {
            encodedJsonValues.nujobsresumedata[num]={};
            encodedJsonValues.nujobsresumedata[num].resumeindex =idx;
            encodedJsonValues.nujobsresumedata[num].resumename =checkBoxData[idx].resumeName;
            encodedJsonValues.nujobsresumedata[num].skilltags =checkBoxData[idx].skills;
            encodedJsonValues.nujobsresumedata[num].isdefault =checkBoxData[idx].isDefault =="Yes"?true:false;

            num++;
        } 
    }     
    const userData = JSON.parse(localStorage.getItem("nujobsUserDetails")); 
    nuJobsUpdateResumeDetails(userData.nujoid,userData.nujuid, encodedJsonValues, nujobsGetMyResumes)
    resetCheckBox();
  };

  const handleDelete = () => {
    // console.log("Selected Resumes for Delete:", selectedResumes);
    var encodedJsonValues = {}
    var num =0

    encodedJsonValues.action = "DELETE"
    encodedJsonValues.nujobsresumedata =[]
    for(let idx = 0; idx < checkBoxData.length; idx++){
       // console.log("checkBoxData", idx,checkBoxData[idx].selected)
        if (checkBoxData[idx].selected) {
           
            encodedJsonValues.nujobsresumedata[num]={};
            encodedJsonValues.nujobsresumedata[num].ResumeIndex =idx;
            num++;
        } 
    }    
     console.log("checkBoxData", encodedJsonValues) 
    const userData = JSON.parse(localStorage.getItem("nujobsUserDetails")); 
    nuJobsUpdateResumeDetails(userData.nujoid,userData.nujuid, encodedJsonValues, nujobsGetMyResumes)
    resetCheckBox();
  };

  const gridTemplate = columnWidth.map((w) => `${w}px`).join(" ");
  const isAnySelected = checkBoxData.some((item) => item.selected);

  const handleOnClick=(rowIndex) =>{
    if (checkBoxData[rowIndex]?.selected) {
      return; // Do nothing, prevent navigation
    }
    if(onClickCallBack !=null){
          onClickCallBack(rowIndex)
    }
  } 
  return (
    <div className="nujobstable-wrapper">
      {
          freeze == true?
          <>
            <div
              className="freeze-control"
              style={{ marginBottom: "10px", position: "sticky", left: "0" }}
            >
              <span style={{ fontSize: "14px" }}>Freeze Columns: </span>
              <input
                type="number"
                min="0"
                max={titleList.length}
                value={frozenColumns}
                onChange={(e) => setFrozenColumns(parseInt(e.target.value))}
                style={{
                  width: "50px",
                  marginLeft: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />
            </div>          
          </>
          :<></>
      }

      <div className="nujobstable-header-buttons">
        {resumePage ? (
          <>
            <Button
              onClick={() => {                
                handleUpdate();
              }}
              disabled={!isAnySelected}
            >
              Update
            </Button>
            <Button
              onClick={() => {
                handleDelete();
              }}
              disabled={!isAnySelected}
            >
              Delete Resume
            </Button>
          </>
        ) : (
          <></>
        )}
      </div>

      <div
        className="nujobstable-title-wrapper"
        style={{
          gridTemplateColumns: gridTemplate,
        }}
      >
        {titleList.map((title, idx) => (
          <div className="nujobstable-title" style={getStickyStyle(idx, "title")}>
            {title}
          </div>
        ))}
      </div>
      {checkBoxData?.map((table, rowIndex) => (
        <div
          onClick={() => handleOnClick(rowIndex)}
          key={table.id}
          className="nujobstable-info-wrapper"
          style={{
            gridTemplateColumns: gridTemplate,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) =>
            tableInfo === "selected" && resumePage ? (
              <div
                className="nujobstable-info"
                style={{
                  ...getFieldStyle(tableInfo, table[tableInfo]),
                  ...getStickyStyle(idx, "info"),
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <Checkbox
                  type="checkbox"
                  checked={table[tableInfo]}
                  onChange={(e) =>
                    handleCheckBoxChange(rowIndex, e.target.checked)
                  }
                />
              </div>
            ) : tableInfo === "resumeName" && resumePage ? (
              <div
                className="nujobstable-info"
                style={{
                  ...getFieldStyle(tableInfo, table[tableInfo]),
                  ...getStickyStyle(idx, "info"),
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {checkBoxData[rowIndex].selected ? (
                  <Input
                    type="text"
                    value={checkBoxData[rowIndex][tableInfo]}
                    onChange={(e) => {
                      const updatedData = [...checkBoxData];
                      updatedData[rowIndex][tableInfo] = e.target.value;
                      setCheckBoxData(updatedData);
                    }}
                  />
                ) : (
                  table[tableInfo]
                )}
              </div>
            ) : tableInfo === "skills" && resumePage ? (
              <div
                className="nujobstable-info"
                style={{
                  ...getFieldStyle(tableInfo, table[tableInfo]),
                  ...getStickyStyle(idx, "info"),
                }}
              >
                {checkBoxData[rowIndex].selected ? (
                  <Input
                    type="text"
                    value={checkBoxData[rowIndex][tableInfo]}
                    onChange={(e) => {
                      const updatedData = [...checkBoxData];
                      updatedData[rowIndex][tableInfo] = e.target.value;
                      setCheckBoxData(updatedData);
                    }}
                  />
                ) : (
                  table[tableInfo]
                )}
              </div>
            ) : (
              <div
                className="nujobstable-info"
                style={{
                  ...getFieldStyle(tableInfo, table[tableInfo]),
                  ...getStickyStyle(idx, "info"),
                }}
              >
                {table[tableInfo]}
              </div>
            ),
          )}
        </div>
      ))}
    </div>
  );
}
